<template>
  <div v-if="isEditable">
    <div v-if="selectedItem && selectedItem.additionalProp1">
      <div class="mB-50">
        <label
          class="pr-2 my-2 align-self-sm-center font-theme-black-color font-weight-medium"
        >
          Web
        </label>
        <div class="banner-wrapper web-banner">
          <div class="accurx-banner-new">
            <div class="section-inner">
              <div class="banner">
                <div class="banner-icon">
                  <img
                    v-if="theme === 'Dark'"
                    :src="web_url_dark"
                    alt="web-icon-dark"
                  />
                  <img
                    v-else-if="theme === 'Light'"
                    :src="web_url_light"
                    alt="web-icon-light"
                  />
                  <img v-else :src="web_url" alt="web-icon" />
                </div>
                <div class="banner-details">
                  <h4
                    v-if="title && showTitle"
                    :style="{ color: textColor, ...h4BorderStyle }"
                  >
                    {{ title }}
                  </h4>
                  <div
                    class="banner-description"
                    :class="{ 'banner-description-2': !showTitle }"
                  >
                    <h1
                      v-if="heading"
                      class="banner-title"
                      :style="{ color: textColor, ...headerStyle }"
                    >
                      {{ heading }}
                    </h1>
                    <p
                      v-if="description"
                      class="banner-text"
                      :style="{ color: textColor }"
                      v-html="description"
                    ></p>
                  </div>
                  <div
                    class="d-flex justify-content-center align-content-center"
                  >
                    <div class="banner-buttons">
                      <a
                        v-if="button_label"
                        :href="button_link"
                        class="banner-button"
                        target="_blank"
                        :style="{
                          backgroundColor: btnColor,
                          color: btnTextColor,
                        }"
                      >
                        {{ button_label }}</a
                      >
                      <a
                        v-if="link_label"
                        :href="link_url"
                        class="banner-button2"
                        target="_blank"
                        :style="{ color: textColor }"
                        >{{ link_label }}</a
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mB-50">
        <label
          class="pr-2 my-2 align-self-sm-center font-theme-black-color font-weight-medium"
        >
          Tablet
        </label>
        <div class="banner-wrapper tablet-banner">
          <div class="accurx-banner-new">
            <div class="section-inner">
              <div class="banner">
                <div class="banner-icon">
                  <img
                    v-if="theme === 'Dark'"
                    :src="tab_url_dark"
                    alt="tablet-icon-dark"
                  />
                  <img
                    v-else-if="theme === 'Light'"
                    :src="tab_url_light"
                    alt="tablet-icon-light"
                  />
                  <img v-else :src="tablet_url" alt="tablet-icon" />
                </div>
                <div class="banner-details">
                  <h4
                    v-if="title && showTitle"
                    :style="{ color: textColor, ...h4BorderStyle }"
                  >
                    {{ title }}
                  </h4>
                  <div
                    class="banner-description"
                    :class="{ 'banner-description-2': !showTitle }"
                  >
                    <h1
                      v-if="heading"
                      class="banner-title"
                      :style="{ color: textColor, ...headerStyle }"
                    >
                      {{ heading }}
                    </h1>
                    <p
                      v-if="description"
                      class="banner-text"
                      :style="{ color: textColor }"
                      v-html="description"
                    ></p>
                  </div>
                  <div
                    class="d-flex justify-content-center align-content-center"
                  >
                    <div class="banner-buttons">
                      <a
                        v-if="button_label"
                        :href="button_link"
                        class="banner-button"
                        target="_blank"
                        :style="{
                          backgroundColor: btnColor,
                          color: btnTextColor,
                        }"
                      >
                        {{ button_label }}</a
                      >
                      <a
                        v-if="link_label"
                        :href="link_url"
                        class="banner-button2"
                        target="_blank"
                        :style="{ color: textColor }"
                        >{{ link_label }}</a
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mB-50">
        <label
          class="pr-2 my-2 align-self-sm-center font-theme-black-color font-weight-medium"
        >
          Mobile
        </label>
        <div class="banner-wrapper mobile-banner">
          <div class="accurx-banner-new">
            <div class="section-inner">
              <div class="banner">
                <div class="banner-icon">
                  <img
                    v-if="theme === 'Dark'"
                    :src="mobile_url_dark"
                    alt="mobile-icon-dark"
                  />
                  <img
                    v-else-if="theme === 'Light'"
                    :src="mobile_url_light"
                    alt="mobile-icon-light"
                  />
                  <img v-else :src="mobile_url" alt="mobile-icon" />
                </div>
                <div class="banner-details">
                  <h4
                    v-if="title && showTitle"
                    :style="{ color: textColor, ...h4BorderStyle }"
                  >
                    {{ title }}
                  </h4>
                  <div
                    class="banner-description"
                    :class="{ 'banner-description-2': !showTitle }"
                  >
                    <h1
                      v-if="heading"
                      class="banner-title"
                      :style="{ color: textColor, ...headerStyle }"
                    >
                      {{ heading }}
                    </h1>
                    <p
                      v-if="description"
                      class="banner-text"
                      :style="{ color: textColor }"
                      v-html="description"
                    ></p>
                  </div>
                  <div
                    class="d-flex justify-content-center align-content-center"
                  >
                    <div class="banner-buttons">
                      <a
                        v-if="button_label"
                        :href="button_link"
                        class="banner-button"
                        target="_blank"
                        :style="{
                          backgroundColor: btnColor,
                          color: btnTextColor,
                        }"
                      >
                        {{ button_label }}</a
                      >
                      <a
                        v-if="link_label"
                        :href="link_url"
                        class="banner-button2"
                        target="_blank"
                        :style="{ color: textColor }"
                        >{{ link_label }}</a
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="" v-else>
    <div class="mB-50">
      <label class="pr-2 my-2 font-theme-black-color font-weight-medium"
        >Web</label
      >
      <div class="banner-icon-new">
        <img v-if="theme === 'Dark'" :src="web_url_dark" alt="web-bg-dark" />
        <img
          v-else-if="theme === 'Light'"
          :src="web_url_light"
          alt="web-bg-light"
        />
        <img v-else :src="web_url" alt="web-bg" />
      </div>
    </div>

    <div class="mB-50">
      <label class="pr-2 my-2 font-theme-black-color font-weight-medium"
        >Tablet</label
      >
      <img v-if="theme === 'Dark'" :src="tab_url_dark" alt="tablet-bg-dark" />
      <img
        v-else-if="theme === 'Light'"
        :src="tab_url_light"
        alt="tablet-bg-light"
      />
      <img v-else :src="tablet_url" alt="tablet-bg" />
    </div>

    <div class="mB-50">
      <label class="pr-2 my-2 font-theme-black-color font-weight-medium"
        >Mobile</label
      >
      <img
        v-if="theme === 'Dark'"
        :src="mobile_url_dark"
        alt="mobile-bg-dark"
      />
      <img
        v-else-if="theme === 'Light'"
        :src="mobile_url_light"
        alt="mobile-bg-light"
      />
      <img v-else :src="mobile_url" alt="mobile-bg" />
    </div>
  </div>
</template>
<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "ResponsiveAccurxBanner",
  props: {
    // Props from the original parent component
    item: {
      type: Object,
      required: true,
    },
    selectedItem: {
      type: Object,
      default: () => null, // Providing a default if not required
    },
    blockClass: String,
    bannerClass: String,
    bannerTitleClass: String,
    bannerWebsiteLink: {
      type: String,
      default: "https://frimley-healthiertogether.nhs.uk/",
    },
    bannerAppleLink: {
      type: String,
      default: "https://apps.apple.com/gb/app/healthier-together/id1507487185",
    },
    bannerGoogleLink: {
      type: String,
      default:
        "https://play.google.com/store/apps/details?id=com.cenigma.healthiertogether",
    },
    last_updated: {
      type: Object,
      required: false,
    },
    updateValue: {
      type: Function,
      required: true, // Kept as per original parent, its usage is not shown in templates
    },
  },
  data() {
    return {
      theme: "Default", // Default theme from original parent
    };
  },
  computed: {
    headerStyle() {
      try {
        return JSON.parse(this.additionalProp1?.headerStyle || "{}");
      } catch (e) {
        return {};
      }
    },
    isEditable() {
      return this.additionalProp1?.isEditable === true;
    },
    // Centralized computed properties from child components
    additionalProp1() {
      // Ensure selectedItem and additionalProp1 exist before trying to access properties
      return this.selectedItem && this.selectedItem.additionalProp1
        ? this.selectedItem.additionalProp1
        : null;
    },
    showTitle() {
      // Use ?? to allow `false` as a valid value
      return this.additionalProp1.showTitle ?? true;
    },
    btnColor() {
      return this.additionalProp1 ? this.additionalProp1.btnColor : "#fff";
    },
    btnTextColor() {
      return this.additionalProp1 ? this.additionalProp1.btnTextColor : "#000";
    },
    textColor() {
      return this.additionalProp1 ? this.additionalProp1.textColor : "#fff";
    },
    // Title, heading, description sourced from selectedItem root
    title() {
      return this.selectedItem ? this.selectedItem.title : "";
    },
    heading() {
      // Assuming heading is also at the root of selectedItem, or empty if not present
      return this.selectedItem ? this.selectedItem.heading : "";
    },
    description() {
      return this.selectedItem ? this.selectedItem.description : "";
    },

    // Button and link details sourced from additionalProp1 (selectedItem.additionalProp1)
    button_label() {
      return this.additionalProp1 ? this.additionalProp1.button_label : "";
    },
    button_link() {
      return this.additionalProp1 && this.additionalProp1.button_link
        ? this.additionalProp1.button_link
        : "#";
    },
    link_label() {
      return this.additionalProp1 ? this.additionalProp1.link_label : "";
    },
    link_url() {
      return this.additionalProp1 && this.additionalProp1.link_url
        ? this.additionalProp1.link_url
        : "#";
    },

    // Image URLs - with checks for additionalProp1
    web_url_dark() {
      return this.additionalProp1 ? this.additionalProp1.web_dark : "";
    },
    mobile_url_dark() {
      return this.additionalProp1 ? this.additionalProp1.mobile_dark : "";
    },
    tab_url_dark() {
      // Handles potential variations like tablet_dark or tab_dark from original components
      return this.additionalProp1
        ? this.additionalProp1.tablet_dark || this.additionalProp1.tab_dark
        : "";
    },
    web_url_light() {
      return this.additionalProp1 ? this.additionalProp1.web_light : "";
    },
    mobile_url_light() {
      // Handles potential variations like mobile_light or mobilelight
      return this.additionalProp1
        ? this.additionalProp1.mobile_light || this.additionalProp1.mobilelight
        : "";
    },
    tab_url_light() {
      return this.additionalProp1
        ? this.additionalProp1.tablet_light || this.additionalProp1.tab_light
        : "";
    },
    web_url() {
      return this.additionalProp1 ? this.additionalProp1.web : "";
    },
    tablet_url() {
      return this.additionalProp1 ? this.additionalProp1.tablet : "";
    },
    mobile_url() {
      return this.additionalProp1 ? this.additionalProp1.mobile : "";
    },

    // NEW: Dynamic border style for h4 elements
    h4BorderStyle() {
      const showBorders = this.additionalProp1?.showHeaderBorders !== false; // Default to true if not specified

      if (showBorders) {
        return {
          borderBottom: "2px solid currentColor",
          borderTop: "2px solid currentColor",
        };
      } else {
        return {
          borderBottom: "none",
          borderTop: "none",
        };
      }
    },
  },
  watch: {
    // Watcher from original parent component
    last_updated: {
      handler(val) {
        if (val && val.key === "theme") {
          this.theme = val.value;
        }
        // console.log("Theme updated via last_updated:", this.theme); // For debugging
      },
      deep: true,
    },
  },
});
</script>

<style lang="scss" scoped>
.logo-offset {
  margin-top: 60px;
}
.banner-icon-new {
  img {
    inline-size: -webkit-fill-available;
  }
}
// Styles from the original parent component
.mB-50 {
  margin-bottom: 50px;
}

// Basic styling for labels (derived from parent's classes)
label.font-theme-black-color {
  // More specific selector
  padding-right: 0.5rem;
  margin-top: 15px !important;
  margin-bottom: 0.5rem;
  // align-self-sm-center would require a flex container for the label's parent
  color: #333; // Assuming font-theme-black-color
  font-weight: 500; // Assuming font-weight-medium
  display: block; // For better spacing control
  margin-bottom: 10px; // Added space below label
}

// --- Common styles for all banner types, derived from child components ---
.banner-wrapper {
  width: 100%;
  display: flex;
  height: 328px;
}

.accurx-banner-new {
  // Default height, can be overridden by specific view styles
  height: 280px;
  background-size: cover;
  // Default background image, can be overridden in media queries
  background-image: url("https://patientlink-uploads.s3.eu-west-2.amazonaws.com/icb_bnrs/ht-banner/bg-kid.png");
  background-position: center center;
  position: relative;
  // The width of accurx-banner-new will be determined by its content (.banner) or by .banner-wrapper

  .banner {
    display: flex;
    align-items: flex-start;
    background-color: transparent; // Default, mobile overrides to #fff
    margin-bottom: 0px;
    overflow: hidden;
    position: relative;
    // Width and height for .banner will be set by specific view styles (.web-banner, .tablet-banner, etc.)
  }

  .banner-icon {
    position: absolute; // Allows precise placement if needed, or relies on flex parent
    // Image within banner-icon will dictate its size primarily
    img {
      display: block; // Good practice for images
      // Specific dimensions (width, height) for img are set in view-specific styles
    }
  }

  .banner-details {
    position: absolute; // Overlay details on the banner
    width: 100%; // Common setting from children
    margin-top: 35px; // Common setting from children
    text-align: center; // Default, can be overridden by media queries
    // Ensure details are centered on the banner
    left: 50%;
    margin-left: 30px;
    transform: translateX(-50%);
    // top: 20px; // margin-top handles this

    h4 {
      font-size: 18px;
      width: 245px;
      padding: 7px 0;
      font-weight: normal;
      letter-spacing: 1px;
      margin: 0 auto; // Centering
      color: #fff; // Default white color
      // Border styles are now controlled dynamically via inline styles
      // border-bottom: 2px solid currentColor;
      // border-top: 2px solid currentColor;
      // text-transform: uppercase;
    }

    .banner-description {
      // height: 205px; // This varied, manage with overflow
      overflow: hidden;
      margin-bottom: 0px;

      .banner-title {
        width: 336px;
        margin: 38px auto 12px auto; // Centering
        font-size: 24px;
        font-weight: 600;
        line-height: 1.42;
        letter-spacing: 1px;
        color: #fff; // Default white color
        // text-transform: uppercase;
      }

      .banner-text {
        width: 336px;
        margin: 0 auto; // Centering
        font-size: 14px;
        line-height: 1.43;
        color: #fff; // Default white color
        -webkit-line-clamp: 5;
        -webkit-box-orient: vertical;
        display: -webkit-box; // Fallback for non-webkit might be needed if an issue
        overflow: hidden;
      }
    }

    .banner-buttons {
      display: block; // Default, web overrides to flex in MQ
      // text-transform: uppercase;
      width: 242px;
      margin: 0 auto; // Centering
    }

    .banner-button {
      padding: 10px 30px;
      font-size: 14px;
      color: #18585f; // Default button text color
      background-color: #fff; // Default button background color
      line-height: 1.43;
      text-decoration: none;
      display: block; // Default
    }

    .banner-button2 {
      line-height: 1.5;
      color: #fff; // Default white color
      display: block;
      text-decoration: none;
      margin-top: 12px;
    }
  }
}

// --- Specific styles for Web Banner ---
.web-banner .accurx-banner-new {
  .banner {
    width: 100%; // Allow banner to be flexible, image will set intrinsic size up to max
    max-width: 850px; // Max width of the image
    height: 328px;
    justify-content: left; // Align image to the left
    img {
      width: 850px;
      height: 328px;
    }
  }
}

// --- Specific styles for Tablet Banner ---
.tablet-banner .accurx-banner-new {
  .banner {
    width: 580px; // Fixed width for tablet banner container
    height: 328px;
    justify-content: center; // Center image within the banner
    img {
      width: 590px; // Image can be slightly wider than its direct container if needed by design
      height: 328px;
    }
  }
}

// --- Specific styles for Mobile Banner ---
.mobile-banner .accurx-banner-new {
  height: 328px; // Mobile banner has a different height
  .banner {
    width: 260px;
    height: 350px;
    justify-content: center;
    background-color: #fff; // Mobile banner has a white background
    img {
      width: 260px;
      height: 350px;
    }
  }
}

// --- Media Queries ---

// Combined Media Queries for Web and Tablet (as they were identical in source)
.web-banner .accurx-banner-new,
.tablet-banner .accurx-banner-new {
  @media (min-width: 768px) {
    // Common background image for larger screens (web/tablet)
    background-image: url("/img/accurx-new/accurx-big-bg.png"); // Ensure this path is correct
    background-position: 53%;
    .banner-details {
      text-align: start; // Align text to start for web/tablet
      // The .banner-details .banner-icon rule from original SCSS:
      // This refers to an icon *inside* the details block, not the main banner image.
      // If such an icon is added to the HTML, these styles will apply.
      .banner-icon {
        display: none; // Initially hidden in details on tablet+
      }
    }
    h4 {
      width: 245px;
      margin: 0;
    } // No longer auto margin for centering
    .banner-description {
      height: 212px;
      .banner-title {
        width: 346px;
        margin: 27px 0px 14px 0;
        font-size: 26px;
        line-height: 1.38;
      }
      .banner-text {
        width: 370px;
        line-height: 1.5;
        margin: 0;
      }
    }
    .banner-buttons {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      width: 100%;
      margin: 0;
      justify-content: start;
    }
    .banner-button {
      margin-right: 20px;
      margin-bottom: 0;
    } // Reset mobile margin-bottom
    .banner-button2 {
      margin-top: 0px;
      font-size: 14px;
    }
  }

  @media (min-width: 992px) {
    background-position: 100%;
    width: 100%;
    .banner-details .banner-icon {
      // Icon inside details, shown here
      width: 140px;
      text-align: end;
      display: block;
      position: absolute;
      right: 0;
      bottom: -9px;
      img {
        width: 100%;
        height: auto;
      }
    }
    .banner-description {
      height: 220px;
      margin-bottom: 5px;
      .banner-title {
        width: 346px;
        margin: 27px 0px 14px 0;
        line-height: 1.33;
      }
    }
  }

  @media (min-width: 1200px) {
    .banner-details .banner-icon {
      bottom: -6px;
    } // Adjust position for icon in details
    h4 {
      font-size: 20px;
      width: 262px;
      white-space: nowrap;
    }
    .banner-description {
      height: 170px;
      margin-bottom: 5px;
      .banner-title {
        width: 560px;
        margin: 23px 0px 12px 0;
        font-size: 25px;
        line-height: 1.33;
      }
      .banner-text {
        width: 375px;
        font-size: 14px;
        -webkit-line-clamp: 6;
      }
    }
    .banner-description-2 {
      height: 230px;
    }
    .banner-button2 {
      font-size: 16px;
    }
  }
}

// Media Queries specific to Mobile Banner view
.mobile-banner .accurx-banner-new {
  @media (min-width: 768px) {
    // Mobile view on larger screens might use a different background
    background-image: url("/img/accurx-new/accurx-big-bg.png"); // Or specific mobile large screen BG
    background-position: 53%; // Or mobile-specific positioning
    // height: 350px; // Remains 350px unless specified otherwise

    .banner-details {
      text-align: center;
      width: 90%; // Mobile keeps text centered
      margin: 10px 0px;
      margin-top: 25px;
      .banner-icon {
        display: none;
      } // Assuming this means an icon within details, if present
    }
    // h4 styling is common from .accurx-banner-new unless overridden
    .banner-description {
      height: 212px; // Common height
      .banner-title {
        width: 346px;
        margin: 27px auto 14px auto;
        font-size: 26px;
        line-height: 1.38;
      } // Centered
      .banner-text {
        width: 370px;
        line-height: 1.5;
        margin: 0 auto;
      } // Centered
    }
    .banner-buttons {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      width: 100%; // Take full width
      margin-top: 20px;
      justify-content: center; // Buttons centered
    }
    .banner-button {
      margin-right: 0px; // No horizontal margin between buttons
      margin-bottom: 5px;
      white-space: nowrap;
    }
    // .banner-button2 styling common unless overridden
  }

  @media (min-width: 992px) {
    background-position: 100%; // Or mobile-specific
    .banner-details .banner-icon {
      // Icon inside details for mobile, if it exists in HTML
      width: 140px;
      text-align: end;
      display: block;
      position: absolute;
      right: 0;
      bottom: -9px;
      img {
        width: 100%;
        height: auto;
      }
    }
    .banner-description {
      height: 220px;
      .banner-title {
        margin: 27px auto 14px auto;
      } // Keep centered
    }
  }

  @media (min-width: 1200px) {
    .banner-details .banner-icon {
      bottom: -6px;
    }
    h4 {
      width: 100%;
      margin: 0 auto;
      white-space: nowrap;
      font-size: 14px;
    } // Full width, centered
    .banner-description {
      height: 170px;
      .banner-title {
        width: 100%;
        margin: 23px auto 12px auto;
        font-size: 25px;
      } // Full width, centered
      .banner-text {
        width: 100%;
        font-size: 14px;
        -webkit-line-clamp: 6;
        margin: 0 auto;
      } // Full width, centered
    }
    // .banner-button2 styling common unless overridden
  }
}
</style>
